/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetUserUsernameQueryResponse,
  GetUserUsernamePathParams,
  GetUserUsername404,
} from "../types/GetUserUsernameUsername.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUserUsernameUsernameQueryKey = (
  username: GetUserUsernamePathParams["username"] | undefined,
) =>
  [
    { url: "/user/username/:username", params: { username: username } },
  ] as const;

export type GetUserUsernameUsernameQueryKey = ReturnType<
  typeof getUserUsernameUsernameQueryKey
>;

/**
 * @summary Получение профиля пользователя по Username.
 * {@link /user/username/:username}
 */
export async function getUserUsernameUsername(
  username: GetUserUsernamePathParams["username"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUserUsernameQueryResponse,
    ResponseErrorConfig<GetUserUsername404>,
    unknown
  >({ method: "GET", url: `/user/username/${username}`, ...requestConfig });
  return res;
}

export function getUserUsernameUsernameQueryOptions(
  username: GetUserUsernamePathParams["username"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUserUsernameUsernameQueryKey(username);
  return queryOptions<
    ResponseConfig<GetUserUsernameQueryResponse>,
    ResponseErrorConfig<GetUserUsername404>,
    ResponseConfig<GetUserUsernameQueryResponse>,
    typeof queryKey
  >({
    enabled: !!username,
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserUsernameUsername(username!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Получение профиля пользователя по Username.
 * {@link /user/username/:username}
 */
export function useGetUserUsernameUsername<
  TData = ResponseConfig<GetUserUsernameQueryResponse>,
  TQueryData = ResponseConfig<GetUserUsernameQueryResponse>,
  TQueryKey extends QueryKey = GetUserUsernameUsernameQueryKey,
>(
  username: GetUserUsernamePathParams["username"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetUserUsernameQueryResponse>,
        ResponseErrorConfig<GetUserUsername404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getUserUsernameUsernameQueryKey(username);

  const query = useQuery(
    {
      ...getUserUsernameUsernameQueryOptions(username, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUserUsername404>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
